<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>服务区域日志</h4>
      </div>
      <div class="c-flex">
        <!-- <el-input
          placeholder="请输入服务区域名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input> -->
        <!-- <el-button
          type="primary"
          class="c-m-l-10"
          v-if="osg.has('ServiceHistory,export')"
          @click="
            osg.doExport({
              smodule: 'serviceTerritory',
              sortField: 'createTime',
              sortOrder: 'desc',
              s_fields: 'name',
              beanName: 'ServiceHistory',
              title: '服务区域日志'
            })
          "
        >
          数据导出
        </el-button> -->
        <el-button
          v-if="osg.has('ServiceHistory,export')"
          type="primary"
          @click="exportNew()"
        >
          数据导出
        </el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data" highlight-current-row>
         <el-table-column
            prop="operation"
            label="操作"
            show-overflow-tooltip
            width="50px"
          ></el-table-column>
          <el-table-column
            prop="exts.name"
            label="服务区域名称"
            show-overflow-tooltip
            width="130px"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="操作时间"
            show-overflow-tooltip
            width="130px"
          ></el-table-column>
          <el-table-column
            prop="createUserName"
            label="操作用户"
            show-overflow-tooltip
            width="130px"
          ></el-table-column> 
          <!-- 修改字段  修改前、修改后-->
          <el-table-column
            prop="modifyList"
            min-width="110px"
          >
            <template slot-scope="scope">
                <div class="activity-card-content">
                    <el-table :data="scope.row.modifyList" >
                    <el-table-column
                        prop="field"
                        label="修改字段"
                        width="110"
                        show-overflow-tooltip
                        :formatter="formatField"
                    ></el-table-column>
                    <el-table-column
                        prop="pfrom"
                        label="修改前"
                        show-overflow-tooltip
                         :formatter="formatFieldValue"
                    ></el-table-column>
                    <el-table-column
                        prop="pto"
                        label="修改后"
                        show-overflow-tooltip
                        :formatter="formatFieldValue"
                    ></el-table-column>
                    </el-table>
                </div>                
            </template>           
          </el-table-column>          
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ServiceHistory',  
  data() {
    // let that = this;
    return {
      name: 'ServiceHistory',
      Name:{},
      fpi: {},
      searchValue: '',
    //   formData: {
    //     country: '中国',
    //     area: []
    //   },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {},
      //地址级联
      // area: {
      //   options: this.osg.areaList,
      //   show: true,
      //   props: {
      //     multiple: true,
      //     lazy: true,
      //     async lazyLoad(node, resolve) {
      //       const { level } = node;
      //       var nodes = [];
      //       if (level == '3') {
      //         node.data.leaf = false;
      //         if (node.children && node.children.length == 0) {
      //           node.children = [];
      //           let id = node.data.value;
      //           let arr = that.subdistrictT;
      //           nodes = await that.$util.getSubdistrict(id,arr);
      //           if (nodes.length == 0) {
      //             node.data.leaf = true;
      //           }
      //         }
      //       }
      //       // 通过调用resolve将子节点数据返回，通知组件数据加载完成
      //       resolve(nodes);
      //     }
      //   }
      // },
      // 返显服务区域关联的服务资源
      serviceResources: [],
      areaShow: true, //视图刷新用
      historyData: {}
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    // this.getName()
    this.getServiceResources();
    this.osg.getFields('serviceTerritory', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    formatField(row, column, cellValue) {
      
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      let field = this.fieldsObj[row.field];
      if (!field) return;
      if (field.frontEndConfig.changeLog_file) {
        cellValue = JSON.parse(cellValue);
        if (Array.isArray(cellValue)) {
          return JSON.stringify(cellValue && cellValue.map(item => item.url));
        }
      }
      if (cellValue) {
        if (row.field == 'orgIds') {
          return cellValue;
        } else if (!field.frontEndConfig.changeLog_file && this.$util.isJson(cellValue)) {
          cellValue = JSON.parse(cellValue);
        }
      }
      if (field && field.valueOption) {
        if (field.type == 'cascade') {
          if (field.frontEndConfig.multiple) {
            return this.osg.formatCascadeMultiple(field.valueOption, cellValue);
          } else {
            return this.osg.formatCascade(field.valueOption, cellValue);
          }
        } else if (field.multiple) {
          return this.osg.codelabelForArray(field.valueOption, cellValue);
        } else {
          return this.osg.codelabel(field.valueOption, cellValue);
        }
      } 
      //   else if (row.field == 'area' || (field && field.type == 'area')) {
      //   let str = ''
      //   cellValue && cellValue.map(item=>{
      //     str += this.osg.formatArea(item);
      //   })
      //   return str + '、';
      // }
        else if (row.field == 'province' || (field && field.type == 'province')) {
          let str = '';
            cellValue && cellValue.map(item=>{
              str += this.osg.formatProvince(null,null,item) + '、';
            });
        return str;
      }
        else if (row.field == 'city' || (field && field.type == 'city')) {
          let str = '';
            cellValue && cellValue.map(item=>{
              str += this.osg.formatCity(null,null,item) + '、';
            });
        return str;
      }
      else if (row.field == 'district' || (field && field.type == 'district')) {
          let str = '';
            cellValue && cellValue.map(item=>{
              str += this.osg.formatDistrict(null,null,item) + '、';
            });
        return str;
      }
      else if (row.field == 'subdistrict' || (field && field.type == 'subdistrict')) {
        let str = '';
          cellValue && cellValue.map(item=>{
            str += this.osg.formatSubdistrict(null,null,item) + '、';
          });
        return str;
      }
      else if (row.field == 'relatedIds' || (field && field.type == 'relatedIds')) {
        let str = '';
        let relatedIds = cellValue || [];
        for (let i = 0; i < relatedIds.length; i++) {
          for (let serviceResource of this.serviceResources) {
            if (relatedIds[i] == serviceResource._id) {
              str += i + 1 + '.' + serviceResource.name + ' ';
            }
          }
        }
        return str;
      }      
       else if (field.type == 'data') {
        return cellValue.join(',');
      } else {
        return cellValue;
      }
    }, 
    // 服务资源返现
    // formatRelatedIds(row, column, cellValue) {
    //   console.log(row, column, cellValue);
    //   let str = '';
    //   let relatedIds = cellValue || [];
    //   for (let i = 0; i < relatedIds.length; i++) {
    //     for (let serviceResource of this.serviceResources) {
    //       if (relatedIds[i] == serviceResource._id) {
    //         str += i + 1 + '.' + serviceResource.name + ' ';
    //       }
    //     }
    //   }
    //   return str;
    // }, 
    getServiceResources() {
      let params = {
        'in:state|array-integer#and': '0,1',
        _all: '1'
      };
      // TODO:dzm服务区域只关联伙伴类型的服务资源
      if (this.tenantId == '1340835581184723420') {
        params['is:resourceType|string#and'] = 'partner';
      }
      this.osg.ajax(
        'biz/serviceResource/query.do',
        params,
        res => {
          if (res.data) {
            this.serviceResources = res.data;
          }
        },
        {
          noload: true
        }
      );
    },      
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    // 日志接口
    getData() {

      var params = {
          sid: this.id,
          page: this.fpi.page || 1,
          rows: this.fpi.rows || 20,
          smodule: 'serviceTerritory',
          sortField: 'createTime',
          sortOrder: 'desc',
          s_fields: 'name',
        // 'regex:createUserName|string#or': this.searchValue,
      };
      //添加过滤器参数
      // $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/changeLog/query.do', params, res => {
          res.data.map(item=>{
            item.modifyList = item.modifyList.filter(modifyList=>{
            return  modifyList.field != 'area';
            });
            this.fpi = res;
          });
                 
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
          /**
   * 数据导出
   */
  exportNew() {
    let params = {
          smodule: 'serviceTerritory',
          sortField: 'createTime',
          sortOrder: 'desc',
          s_fields: 'name',
      };
    window.$that.getParams(params);
    this.osg.setFpi(params);
    params = Object.assign(params);
    this.osg.ajax(
      '/basic/serviceTerritory/changeLog/export.do',
      params,
      res => {
        this.offlineExportBack()
       
      },
      {
        responseType: 'blob'
      }
    );
  },
    //导出成功回调
    offlineExportBack() {
      this.osg.alert('操作成功！正在生成文件... 点击跳转查看', () => {
        this.$router.push({ path: '/Stask' });
      });
    },
  }
};
</script>
<style lang="scss">
.header-50 {
  height: 51px !important;
}
</style>
